import React from 'react';
import { Row, Col, Card, Select } from 'antd';
import TransactionPublisherRingChart from './TransactionPublisherRingChart';
import { prepareCTR } from '../../../../../../../../core/utils/campaigns';
// Global Styling
import {
  CardTitleText,
  MenuItemText,
  TableColumnTitle,
} from '../../../../../../../shared/globalStyling/styledText';
//colors
import { colors } from '../../../../../../../../core/utils/constants/listOfColors';
import TransactionPublisherTable from './TransactionPublisherTable';

const { Option } = Select;
const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
    marginTop: 10,
    marginBottom: 10,
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  keyColors,
  campaignCardStyle,
  campaignCardStyleCreatives,
} = Style;

const options = [
  {
    value: 'impressions',
    text: 'Impressions',
  },
  {
    value: 'totalTransactions',
    text: 'Transactions',
  },
];

const Extra = ({ setPublisherDimension }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '4px' }}>
      <div style={{ whiteSpace: 'nowrap' }}>
        <CardTitleText text={'Breakdown'} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', minWidth: 0, gap: '4px' }}>
        <span style={{ whiteSpace: 'nowrap' }}>
          <TableColumnTitle text={'Show By:'} />
        </span>
        <Select
          style={{ minWidth: '80px', maxWidth: '140px' }}
          defaultValue={options[0].value}
          onChange={(value) => {
            setPublisherDimension(value);
          }}
        >
          {options.map((option, index) => {
            return (
              <Option key={index} value={option.value}>
                <MenuItemText text={option.text} />
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

const TransactionPublisherDetails = (props) => {
  const { transactionsPublishers, publisherDimension, setPublisherDimension } = props;

  if (!transactionsPublishers || transactionsPublishers.length === 0) {
    return null;
  }

  const formatTransactionData = transactionsPublishers.map((val) => ({
    imageUrl: val.mediaSource ? val.mediaSource : '', //TODO IMAGE URL OF PUBLISHER
    impressions: val.impressions,
    totalTransactions: val.totalTransactions,
    xAxis: val.title ? val.title : val.IMPRESSION_SITENAME,
  }));

  if (!formatTransactionData || formatTransactionData.length === 0) {
    return null;
  }

  const parsedData = prepareCTR(formatTransactionData);
  if (!parsedData || parsedData.length === 0) {
    return null;
  }

  const colorValuePairs = parsedData.map((el, index) => {
    if (el.xAxis) {
      return {
        ...el,
        value: el.xAxis,
        color: colors[index],
      };
    } else if (el.value) {
      return {
        ...el,
        color: colors[index],
      };
    }
    return {
      ...el,
      value: `Creative ${index}`,
      color: colors[index],
    };
  });

  if (!Array.isArray(colorValuePairs) || colorValuePairs.length === 0) {
    return null;
  }

  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} style={{ position: 'relative', zIndex: 1, overflow: 'visible' }}>
        <Card
          style={{ ...campaignCardStyleCreatives, overflow: 'visible' }}
          headStyle={{ borderWidth: '3px', height: '66px' }}
          bodyStyle={{ padding: 0, overflow: 'visible' }}
          title={<CardTitleText text={'Publishers'} />}
        >
          <TransactionPublisherTable publisherData={colorValuePairs} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px', minHeight: '66px', height: 'auto' }}
          title={<Extra setPublisherDimension={setPublisherDimension} />}
        >
          <TransactionPublisherRingChart
            data={colorValuePairs}
            keyColors={keyColors}
            height={campaignCardStyle.height}
            selectedPublisherDimension={publisherDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default TransactionPublisherDetails;
